module.exports = __webpack_public_path__ + "static/10-a1f1af04bf502a2a2c14c4f675498cb3.jpg";